/**
 * @memberof firebird
 * @ngdoc directive
 * @name animation
 * @param {service} $timeout
 *   Angular window.setTimeout wrapper
 * @description
 *   Implementation of Animate.CSS effects. Initializes an element with 'animation' class, along with the type of animation.
 *
 *   This directive is implemented as an Attribute, with the value being
 *   the type of animation you want. i.e. fadeIn, fadeOut, bounceIn, bounceOut
 *
 *   Examples animations can be found at https://daneden.github.io/animate.css/
 *
 * @example
 *   <div animation="fadeIn">This div will fade in on pageload</button>
 */

firebird.directive('timedAnimation', [
    '$timeout',
    '$interval',
    function ($timeout, $interval) {
        /**
         * @memberof animation
         * @description
         *   Directive's link function
         * @param {service} scope the scope of this element
         * @param {service} element element that this direcive is assigned to
         * @param {service} attrs attribute of this element
         */
        var linkFunc = function (scope, element, attrs) {
            var animation = attrs.timedAnimation;
            var duration = attrs.timedAnimationDuration;
            var interval = attrs.timedAnimationInterval;

            if (!interval) {
                return;
            }

            $interval(function () {
                element.addClass(animation);
                $timeout(function () {
                    element.removeClass(animation);
                }, duration);
            }, interval);
        };

        return {
            restrict: 'A',
            link: linkFunc
        };
    }
]);
